import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useGetPartnerInviteStatus } from "#/components/partner-access/hooks/usePartnerAccess"
import { PartnerInviteStatus } from "#/components/partner-access/partnerAccessTypes"
import useGetBenefit from "#/components/dynamic-content/hooks/useGetBenefit"

export function PartnerInfoNeededDecisionStep(): JSX.Element {
  const benefitConfiguration = useGetBenefit()
  const lgbtqEnabled = benefitConfiguration.data?.generalSupport.showLgbtqContent
  const { inviteData, isInviteStatusLoading } = useGetPartnerInviteStatus()
  const { send } = useStateMachine()

  useEffect(() => {
    // in restricted countries (lgbtq content disabled) we can't show or collect info on partners
    if (!lgbtqEnabled) {
      send("NO")
      return
    }

    if (!isInviteStatusLoading) {
      const hasInviteBeenSent =
        inviteData?.status === PartnerInviteStatus.INVITED || inviteData?.status === PartnerInviteStatus.ACTIVE
      send(hasInviteBeenSent ? "NO" : "YES")
      return
    }
  }, [isInviteStatusLoading, inviteData, send, lgbtqEnabled])
  return <></>
}
